import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { clearAuth } from '../../store/authSlice';
import { clearUsersList } from '../../store/usersSlice';

interface HeaderProps {
  title: string;
}

export const Header: React.FC<HeaderProps> = ({ title }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [timeStr, setTimeStr] = useState('');
  
  // Redux se profile data lo
  const profile = useAppSelector((state) => state.auth.profile);
  console.log("profiel",profile);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      // Format: 12:00 AM, 02 Feb 2025
      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const minStr = minutes < 10 ? '0' + minutes : minutes;
      
      const day = now.getDate();
      const dayStr = day < 10 ? '0' + day : day;
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[now.getMonth()];
      const year = now.getFullYear();

      setTimeStr(`${hours}:${minStr} ${ampm}, ${dayStr} ${month} ${year}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  // Generate initials from user name
  const getInitials = (name?: string): string => {
    if (!name) return 'U';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  };

  const handleLogout = () => {
    // Clear localStorage session & tokens
    localStorage.removeItem('gowardhan_erp_token');
    localStorage.removeItem('gowardhan_erp_session');
    localStorage.removeItem('gowardhan_erp_profile');
    
    // Clear Redux state
    dispatch(clearAuth());
    dispatch(clearUsersList());

    // Redirect to login screen
    navigate('/', { replace: true });
  };

  const rawName = profile?.user?.name || profile?.name;
  const userName = rawName || 'User';
  const userInitials = getInitials(rawName);

  return (
    <header className="min-h-[60px] sm:h-[75px] bg-white border-b border-[#ECECF2] px-3 sm:px-6 lg:px-8 flex items-center justify-between select-none shrink-0 shadow-xs gap-2">
      
      {/* Title & Time */}
      <div className="flex flex-col min-w-0 flex-1 mr-1 sm:mr-2">
        <h2 className="text-sm sm:text-lg lg:text-xl font-bold text-slate-800 m-0 leading-tight truncate">
          {title}
        </h2>
        <span className="text-[10px] sm:text-[11px] font-semibold text-slate-400 mt-0.5 tracking-wider truncate">
          {timeStr}
        </span>
      </div>

      {/* User Info & Actions */}
      <div className="flex items-center gap-2 sm:gap-4 shrink-0">
        
        {/* User Account Info */}
        <div className="flex items-center gap-2">
          <div
            className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#002B49] text-white flex items-center justify-center font-bold text-xs sm:text-sm shadow-md shadow-[#002B49]/15 select-none shrink-0"
            title={userName}
          >
            {userInitials}
          </div>
          <div className="hidden md:flex flex-col min-w-0">
            <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider leading-none">
              Welcome
            </span>
            <span className="text-xs font-bold text-slate-700 leading-tight mt-0.5 truncate max-w-[120px]">
              {userName}
            </span>
          </div>
        </div>

        {/* Dedicated Logout Button */}
        <button
          onClick={handleLogout}
          className="px-2.5 py-1.5 sm:px-3.5 sm:py-1.5 border border-rose-200 hover:bg-rose-50 text-rose-600 rounded-lg text-xs font-bold transition-all duration-150 flex items-center gap-1 cursor-pointer shadow-xs shrink-0"
          title="Logout"
        >
          <svg className="w-3.5 h-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span className="hidden sm:inline">Logout</span>
        </button>

      </div>

    </header>
  );
};

